export default {
    // user role
    ADMIN:                  1,
    ASSIGNEE:               2,
    CLIENT:                 3,
    EXT_USER:               10,

    // Access type
    ACCESS_WIDGET_SETTING:  1,
    ACCESS_PUBLIC_COMMENT:  2,
    ACCESS_SESSION_REPLAY:  3,

    // Upgrade type
    UPGRADE_TYPE_NONE:      0,
    UPGRADE_TYPE_REFERRAL:  1,

    QUEUE_PENDING:          0,
    QUEUE_PROCESSING:       1,
    QUEUE_COMPLETED:        2,
    QUEUE_FAILED:           3,

    // Queue monitor
    QUEUE_MONITOR_STOPPED:  0,
    QUEUE_MONITOR_RUNNING:  1,

    // account plan
    PLAN_2022_SOLO:         11,
    PLAN_2022_STARTUP:      12,
    PLAN_2022_COMPANY:      13,
    PLAN_2022_PREMIUM:      14,

    PLAN_2024_STARTER:      22,
    PLAN_2024_SCALE:        23,
    PLAN_2024_STARTER_A:    32,
    PLAN_2024_SCALE_A:      33,
    PLAN_2024_CUSTOM:       100,

    PLAN_2025_FREE:          41,
    PLAN_2025_TEAM:          42,
    PLAN_2025_BUSINESS:      43,
    PLAN_2025_BUSINESS_PLUS: 44,
    PLAN_2025_CUSTOM:        200,

    // add-ons
    ADD_ON_VIDEO:           1,

    MONTHLY:                1,
    ANNUALLY:               2,

    TRIAL_PERIOD:           14, // 14 days

    PORTAL_LIMIT:           5,

    TRANSACTION_PENDING:    0,
    TRANSACTION_CHARGED:    1,
    TRANSACTION_DECLINED:   2,

    UNPAID:                 0,
    PAID:                   1,
    OVERDUE:                2,

    FREE_FEEDBACK_EXPIRY: 7, // 7 days,

    // feedback type
    FEEDBACK_GENERAL:         0,
    FEEDBACK_BUG:             1,
    FEEDBACK_FEATURE_REQUEST: 2,

    // action required status
    ACTION_REQUIRED_NOT_SET: 0,
    ACTION_REQUIRED_PENDING: 1,
    ACTION_REQUIRED_HANDLED: 2,

    BOT_JIRA:               -101,
    BOT_CLICKUP:            -102,
    BOT_LINEAR:             -103,
    BOT_EMAIL:              -104,

    PROMO_CODE_LIFE_TIME:   1,
    PROMO_CODE_SINGLE:      2,

    // feedback comment template access type
    FEEDBACK_COMMENT_TEMPLATE_ACCESS_TYPE_ALL: 1,
    FEEDBACK_COMMENT_TEMPLATE_ACCESS_TYPE_MYSELF: 2,

    RRWEB_EVENT_TYPE: {
        DomContentLoaded: 0,
        Load: 1,
        FullSnapshot: 2,
        IncrementalSnapshot: 3,
        Meta: 4,
        Custom: 5,
        Plugin: 6
    },

    RRWEB_INCREMENTAL_SOURCE: {
        CanvasMutation: 9,
        Drag: 12,
        Font: 10,
        Input: 5,
        Log: 11,
        MediaInteraction: 7,
        MouseInteraction: 2,
        MouseMove: 1,
        Mutation: 0,
        Scroll: 3,
        StyleDeclaration: 13,
        StyleSheetRule: 8,
        TouchMove: 6,
        ViewportResize: 4
    },

    RRWEB_MOUSE_INTERACTIONS: {
        Blur: 6,
        Click: 2,
        ContextMenu: 3,
        DblClick: 4,
        Focus: 5,
        MouseDown: 1,
        MouseUp: 0,
        TouchCancel: 10,
        TouchEnd: 9,
        TouchMove_Departed: 8
    },

    // 10 seconds
    RRWEB_SKIP_TIME_THRESHOLD: 10 * 1000,

    // signup code
    SIGNUP_CODE_1ST_MONTH_FREE: '0987UGFDC648YIUESRTJHK89478RIU',

    // user segment
    USER_SEGMENT_TYPE_AND: 0,
    USER_SEGMENT_TYPE_OR:  1,

    // event filter type
    EVENT_CONDITION_TYPE_AND: 0,
    EVENT_CONDITION_TYPE_OR: 1,

    // question filter type
    QUESTION_CONDITION_TYPE_AND: 0,
    QUESTION_CONDITION_TYPE_OR: 1,

    WEBHOOK_EVENT_FEEDBACK_ADD_OLD: 0,
    WEBHOOK_EVENT_FEEDBACK_ADD:     1,
    WEBHOOK_EVENT_FEEDBACK_DELETE:  2,
    WEBHOOK_EVENT_FEEDBACK_ASSIGN:  3,
    WEBHOOK_EVENT_FEEDBACK_VOTE:    4,
    WEBHOOK_EVENT_FEEDBACK_STATUS:  5,
    WEBHOOK_EVENT_FEEDBACK_PRIORITY:6,
    WEBHOOK_EVENT_COMMENT_ADD:      7,
    WEBHOOK_EVENT_COMMENT_EDIT:     8,
    WEBHOOK_EVENT_COMMENT_DELETE:   9,
    WEBHOOK_EVENT_COMMENT_STATUS:   10,
    WEBHOOK_EVENT_SURVEY_RESPONSE_ADD:       30,
    WEBHOOK_EVENT_SURVEY_RESPONSE_DELETE:    31,

    FILE_BLOCK_LIST: [
        'ade',
        'adp',
        'apk',
        'appx',
        'appxbundle',
        'bat',
        'cab',
        'chm',
        'cmd',
        'com',
        'cpl',
        'dll',
        'dmg',
        'ex',
        'ex_',
        'exe',
        'hta',
        'ins',
        'isp',
        'iso',
        'jar',
        'js',
        'jse',
        'lib',
        'lnk',
        'mde',
        'msc',
        'msi',
        'msix',
        'msixbundle',
        'msp',
        'mst',
        'nsh',
        'pif',
        'ps1',
        'scr',
        'sct',
        'shb',
        'sys',
        'vb',
        'vbe',
        'vbs',
        'vxd',
        'wsc',
        'wsf',
        'wsh'
    ]
};